import { HStack, Text } from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

import { LineItemType } from "../../hooks/__generated__/useGetLineItemsAndPriceForRound_Round.graphql";

type LineItem =
  | {
      readonly __typename: string;
      readonly id?: string;
      readonly name: string;
      readonly price: number;
      readonly rounds?:
        | ReadonlyArray<
            | {
                readonly id: string;
              }
            | null
            | undefined
          >
        | null
        | undefined;
      readonly type: LineItemType;
    }
  | null
  | undefined;

type RoundLineItemProps = {
  idx: number;
  lineItem: LineItem;
};

export const RoundLineItem = ({ idx, lineItem }: RoundLineItemProps) => {
  const { currencySymbol } = useGetClubCurrency();
  return (
    <HStack
      justifyContent="space-between"
      marginLeft={9}
      alignItems="center"
      key={idx}
      testID={`line-item-${lineItem?.name}`}
    >
      <Text variant="mainBaseMedium" color="text-primary" lineHeight={32}>
        {lineItem?.name}
      </Text>
      <Text variant="mainBaseMedium" color="text-primary" lineHeight={32}>
        {`${currencySymbol}${ConvertCentsToDollars(lineItem?.price ?? 0)}`}
      </Text>
    </HStack>
  );
};
